<template>
    <div class="pp-cell-expand">
        <pCell ref="cell" class="pp-cell-expand__inner" 
            v-bind="$attrs"
            :with-more="false"
            @click="click">
            <template v-if="$slots.prefix" slot="prefix">
                <slot name="prefix"></slot>
            </template>
            <template v-if="$slots.default">
                <slot></slot>
            </template>
            <i v-if="showIcon" slot="suffix" :class="iconClass"></i>
        </pCell>
        <transition 
            @enter="enter" 
            @leave="leave">
            <div v-show="isActive" class="pp-cell-expand__wrap"
                :style="{ height: height+'px', }">
                <div class="pp-cell-expand__content">
                    <slot name="suffix"></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import pCell from '../../cell'

export default {
    name: 'pp-cell-expand',
    inject: {
        CellGroup: {
            default: '',
        },
    },
    components: {
        pCell,
    },
    props: {
        showIcon: {
            type: Boolean,
            default: true,
        },
    },
    data: function() {
        return {
            isActive: false,
            height: '',
        };
    },
    computed: {
        iconClass: function() {
            return this.isActive 
                ? 'pp-icon-arrow-up' 
                : 'pp-icon-arrow-down';
        },
    },
    watch: {
        isActive: function(n, o) {
            this.$emit(n ? 'open' : 'close')
        },
    },
    methods: {
        enter: function(el) {
            this.height = el.firstChild.offsetHeight
        },

        leave: function(el) {
            this.height = 0
        },

        click: function() {
            this.isActive = !this.isActive
        },
    },
}
</script>

<style>

</style>
